import * as React from 'react';
import { ThemeContext } from 'styled-components';
import { getThemeVariant } from './theme';
export var useThemeVariant = function () {
    var theme = React.useContext(ThemeContext);
    return getThemeVariant({ theme: theme });
};
//# sourceMappingURL=useThemeVariant.js.map